import { Grid, MenuItem, TextField } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  setClickActionBoxLocationFollowOffset,
  setClickActionBoxLocationType,
} from "../../redux";
import {
  getClickActionBoxLocationFollowXOffset,
  getClickActionBoxLocationFollowYOffset,
  getClickActionBoxLocationType,
  getCurrentHotspot,
} from "../../redux/selectors";
import { numberPattern, numberRegex } from "../../util/general";
import { useStyles } from "../../util/useStyles";
import { ClickActionBoxLocationFixedInput } from "../ClickActionBoxLocationFixedInput/ClickActionBoxLocationFixedInput";
import Label from "../Label/Label";

export function ConfigureClickActionBoxLocation() {
  const classes = useStyles();
  const locationType = useSelector(getClickActionBoxLocationType);
  const x = useSelector(getClickActionBoxLocationFollowXOffset);
  const y = useSelector(getClickActionBoxLocationFollowYOffset);
  const dispatch = useDispatch();
  const hotspotIndex = useSelector(getCurrentHotspot);
  function handleSelectChange(e) {
    dispatch(
      setClickActionBoxLocationType({ hotspotIndex, value: e.target.value })
    );
  }
  function handleFollowOffsetChange(e, coordinateName) {
    const value = e.target.value === "" ? undefined : e.target.value;
    if (value && !numberRegex.test(e.target.value)) {
      return;
    }
    dispatch(
      setClickActionBoxLocationFollowOffset({
        hotspotIndex,
        coordinateName,
        coordinateValue: value,
      })
    );
  }
  return (
    <div>
      <div className="configureMessageHeaderContainer">
        <Label>Message location</Label>
        <div className="configureMessageHeaderSpacer" />
        <TextField
          className="configureMessageHeaderRight"
          select
          value={locationType}
          onChange={handleSelectChange}
          InputProps={{
            classes: {
              input: classes.menuItem,
            },
          }}
        >
          <MenuItem value="follow">Follow hotspot</MenuItem>
          <MenuItem value="fixed">Fixed</MenuItem>
        </TextField>
      </div>
      <div className="spacer" />
      {locationType === "fixed" ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <ClickActionBoxLocationFixedInput coordinate="x" />
          </Grid>
          <Grid item xs={6}>
            <ClickActionBoxLocationFixedInput coordinate="y" />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              value={x}
              label="x offset"
              onChange={(e) => handleFollowOffsetChange(e, "x")}
              inputProps={{ inputMode: "numeric", pattern: numberPattern }}
              InputProps={{
                classes: {
                  input: classes.menuItem,
                },
              }}
            ></TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              value={y}
              label="y offset"
              onChange={(e) => handleFollowOffsetChange(e, "y")}
              inputProps={{ inputMode: "numeric", pattern: numberPattern }}
              InputProps={{
                classes: {
                  input: classes.menuItem,
                },
              }}
            ></TextField>
          </Grid>
        </Grid>
      )}
    </div>
  );
}
